<template>
	<div class="main">
		<settings-banner v-if="isDesktopDevice" class="mb-10" />
		<div v-else class="profile-heading mt-5 mb-3">Profile Settings</div>
		<ProfileEditDashboard></ProfileEditDashboard>
		<div class="my-8"></div>
	</div>
</template>



<script setup>

import { isDesktop } from "@/utils/utils.ts";
import SettingsBanner from "@/components/Profile/Settings-Banner.vue";
import ProfileEditDashboard from "@/components/Profile/Profile-Edit-Dashboard.vue";

const isDesktopDevice = isDesktop();

</script>